<template>
    <div class="global-address-administration__edit">
        <div v-if="validationFailed" class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="error-general">
                    <p class="error-general__label">{{ $t("errors.general.headline")}}</p>
                    <p class="error-general__message">{{ validationFailed }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group" :class="validationCountry ? 'has-fe-error': ''">
                    <label for="alternate-address--country" class="form__label">{{ $t("labels.addressFields.country") }}</label>
                    <select id="alternate-address--country" v-model="affectedAddress.country" class="form__select" @select="$emit('update:affectedAddress', affectedAddress)">
                        <option disabled selected value>{{ $t("labels.choose") }}</option>
                        <template v-for="(country, key) in countries">
                            <option :value="key">{{ country }}</option>
                        </template>
                    </select>
                    <div v-if="validationCountry" class="form__error"><span class="form__fe-error">{{ validationCountry }}</span><span class="form__be-error"></span></div>
                </div>
                <div class="form-group">
                    <label for="alternate-address--company" class="form__label">{{ $t("labels.addressFields.company") }}</label>
                    <input id="alternate-address--company" v-model="affectedAddress.company" class="form__input form__input--text" type="text" @change="$emit('update:affectedAddress', affectedAddress)">
                    <div class="form__error"><span class="form__fe-error">{{ errors.street }}</span><span class="form__be-error"></span></div>
                </div>

                <div class="form-group" :class="validationFirstName ? 'has-fe-error': ''">
                    <label for="alternate-address--first-name" class="form__label">{{ $t("labels.addressFields.firstName") }}</label>
                    <input id="alternate-address--first-name" v-model="affectedAddress.firstName" class="form__input form__input--text" type="text" @change="$emit('update:affectedAddress', affectedAddress)">
                    <div v-if="validationFirstName" class="form__error"><span class="form__fe-error">{{ validationFirstName }}</span><span class="form__be-error"></span></div>
                </div>

                <div class="form-group" :class="validationLastName ? 'has-fe-error': ''">
                    <label for="alternate-address--last-name" class="form__label">{{ $t("labels.addressFields.lastName") }}</label>
                    <input id="alternate-address--last-name" v-model="affectedAddress.lastName" class="form__input form__input--text" type="text" @change="$emit('update:affectedAddress', affectedAddress)">
                    <div v-if="validationLastName" class="form__error"><span class="form__fe-error">{{ validationLastName }}</span><span class="form__be-error"></span></div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group" :class="validationStreet ? 'has-fe-error': ''">
                    <label for="alternate-address--street" class="form__label">{{ $t("labels.addressFields.street") }}</label>
                    <input id="alternate-address--street" v-model="affectedAddress.street" class="form__input form__input--text" type="text" @change="$emit('update:affectedAddress', affectedAddress)">
                    <div v-if="validationStreet" class="form__error"><span class="form__fe-error">{{ validationStreet }}</span><span class="form__be-error"></span></div>
                </div>

                <div class="form-group" :class="validationPostCode ? 'has-fe-error': ''">
                    <label for="alternate-address--postcode" class="form__label">{{ $t("labels.addressFields.postCode") }}</label>
                    <input id="alternate-address--postcode" v-model="affectedAddress.postCode" class="form__input form__input--text" type="text" @change="$emit('update:affectedAddress', affectedAddress)">
                    <div v-if="validationPostCode" class="form__error"><span class="form__fe-error">{{ validationPostCode }}</span><span class="form__be-error"></span></div>
                </div>

                <div class="form-group" :class="validationCity ? 'has-fe-error': ''">
                    <label for="alternate-address--city" class="form__label">{{ $t("labels.addressFields.city") }}</label>
                    <input id="alternate-address--city" v-model="affectedAddress.city" class="form__input form__input--text" type="text" @change="$emit('update:affectedAddress', affectedAddress)">
                    <div v-if="validationCity" class="form__error"><span class="form__fe-error">{{ validationCity }}</span><span class="form__be-error"></span></div>
                </div>
                <div class="form-group" :class="validationPhone ? 'has-fe-error': ''">
                    <label for="alternate-address--phone" class="form__label">{{ $t("labels.addressFields.phone") }}</label>
                    <input id="alternate-address--phone" v-model="affectedAddress.phone" class="form__input form__input--text" type="text" @change="$emit('update:affectedAddress', affectedAddress)">
                    <div v-if="validationPhone" class="form__error"><span class="form__fe-error">{{ validationPhone }}</span><span class="form__be-error"></span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {countries} from "@global/utilities/global-country-data";

export default {
    name: "global-address-administration-edit",
    props: ["affectedAddress", "addresses", "errors"],
    data() {
        return {
            countries: countries()
        }
    },
    computed: {
        validationFailed() {
            return this.errors.general && this.errors.general.validationFailed ? this.errors.general.validationFailed : false
        },
        validationFirstName() {
            return this.errors.addressFields && this.errors.addressFields.firstName ? this.errors.addressFields.firstName : false
        },
        validationLastName() {
            return this.errors.addressFields && this.errors.addressFields.lastName ? this.errors.addressFields.lastName : false
        },
        validationStreet() {
            return this.errors.addressFields && this.errors.addressFields.street ? this.errors.addressFields.street : false
        },
        validationPostCode() {
            return this.errors.addressFields && this.errors.addressFields.postCode ? this.errors.addressFields.postCode : false
        },
        validationCity() {
            return this.errors.addressFields && this.errors.addressFields.city ? this.errors.addressFields.city : false
        },
        validationCountry() {
            return this.errors.addressFields && this.errors.addressFields.country ? this.errors.addressFields.country : false
        },
        validationPhone() {
            return this.errors.addressFields && this.errors.addressFields.phone ? this.errors.addressFields.phone: false;
        }
    }

}
</script>
